export interface PlaceGeometry {
    location: {
        lat: number;
        lng: number;
    };
    viewport?: {
        northeast: { lat: number; lng: number };
        southwest: { lat: number; lng: number };
    };
}

export interface PlaceDetails {
    place_id: string;
    name: string;
    formatted_address: string;
    geometry: PlaceGeometry;
    types: string[];
    business_status?: string;
    icon?: string;
    vicinity?: string;
}

export async function fetchPlaceDetails(
    placeId: string
): Promise<PlaceDetails | null> {
    if (!placeId) {
        console.error('No place_id provided');
        return null;
    }

    const endpoint = `https://places-api-manager-613221148836.europe-west1.run.app/placesreq?action=placeDetails&place_id=${encodeURIComponent(placeId)}`;

    try {
        const response = await fetch(endpoint);
        const data = await response.json();

        if (data.status === 'OK' && data.result) {
            return data.result;
        } else if (data.status === 'REQUEST_DENIED') {
            console.error('❌ Google Places API Request Denied');
            console.error('Error message:', data.error_message);
            return null;
        } else {
            console.error('Failed to fetch place details:', data.status);
            return null;
        }
    } catch (error) {
        console.error('Place details fetch error:', error);
        return null;
    }
}
